import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/stores';
import { ITaiKhoan } from 'src/types/TaiKhoan.type';
import { setTaiKhoan } from './TaiKhoan.slice';

export default function useTaiKhoan() {
  const dispatch = useDispatch();
  const taiKhoan = useAppSelector((state) => state.taiKhoan);

  const doiTaiKhoan = (taiKhoan: ITaiKhoan | null) => {
    dispatch(setTaiKhoan(taiKhoan));
  };

  const clear = () => {
    doiTaiKhoan(null);
  };

  return {
    taiKhoan,
    doiTaiKhoan,
    clear,
  };
}
